const NotificationHelperTwo = {

    getDefaultPreferenceData(preferenceData, contractNumber, multiSelect) {
        /***********************
        Change type : Security changes for phone numbers
        Changed by: Sai Aman Pothuganti
        Date : 06-10-2020
        ************************/
        var dataObj = {
            ...preferenceData,
            contractNum: contractNumber,
            addContactLimitArr: { 'email': 0, 'voice': 0, 'text': 0 },
            addContactValueArr: { 'email': ['', '', ''], 'voice': ['', '', ''], 'text': ['', '', ''] },
            addContactEncValueArr: { 'email': ['', '', ''], 'voice': ['', '', ''], 'text': ['', '', ''] },
            addContactCheckedStatusArr: { 'email': [false, false, false], 'voice': [false, false, false], 'text': [false, false, false] }
        };
        if (multiSelect) {
            dataObj.assignedStatusArray = [];
            return dataObj;
        }
        var activeEmailCount = 0;
        var activeVoiceCount = 0;
        var activeTextCount = 0;
        preferenceData.emailSet.map((email) => {
            if (email.objectKey === contractNumber && email.status === 'A') activeEmailCount += 1;
            if (email.objectKey === contractNumber && email.status === 'A' && activeEmailCount === 1) {
                dataObj = this.updateSelectedContactData(dataObj, 'email', 1, email.email, "");
            } else if (email.objectKey === contractNumber && email.status === 'A' && activeEmailCount === 2) {
                dataObj = this.updateSelectedContactData(dataObj, 'email', 2, email.email, "");
            } else if (email.objectKey === contractNumber && email.status === 'A' && activeEmailCount === 3) {
                dataObj = this.updateSelectedContactData(dataObj, 'email', 3, email.email, "");
            }
        });
        preferenceData.mobileSet.map((text) => {
            if (text.objectKey === contractNumber && text.status === 'A') activeTextCount += 1;
            if (text.objectKey === contractNumber && text.status === 'A' && activeTextCount === 1) {
                dataObj = this.updateSelectedContactData(dataObj, 'text', 1, text.telephoneNumber, text.encryptedPhoneNumber);
            } else if (text.objectKey === contractNumber && text.status === 'A' && activeTextCount === 2) {
                dataObj = this.updateSelectedContactData(dataObj, 'text', 2, text.telephoneNumber, text.encryptedPhoneNumber);
            } else if (text.objectKey === contractNumber && text.status === 'A' && activeTextCount === 3) {
                dataObj = this.updateSelectedContactData(dataObj, 'text', 3, text.telephoneNumber, text.encryptedPhoneNumber);
            }
        });
        preferenceData.phoneSet.map((phone) => {
            if (phone.objectKey === contractNumber && phone.status === 'A') activeVoiceCount += 1;
            if (phone.objectKey === contractNumber && phone.status === 'A' && activeVoiceCount === 1) {
                dataObj = this.updateSelectedContactData(dataObj, 'voice', 1, phone.telephoneNumber, phone.encryptedPhoneNumber);
            } else if (phone.objectKey === contractNumber && phone.status === 'A' && activeVoiceCount === 2) {
                dataObj = this.updateSelectedContactData(dataObj, 'voice', 2, phone.telephoneNumber, phone.encryptedPhoneNumber);
            } else if (phone.objectKey === contractNumber && phone.status === 'A' && activeVoiceCount === 3) {
                dataObj = this.updateSelectedContactData(dataObj, 'voice', 3, phone.telephoneNumber, phone.encryptedPhoneNumber);
            }
        });
        var fieldKeys = ['emailSet', 'mobileSet', 'phoneSet'];
        var indicatorKeys = { emailSet: 'standardIndicatorEmail', mobileSet: 'standardIndicatorText', phoneSet: 'standardIndicatorVoice' };
        for (var i = 0; i < fieldKeys.length; i++) {
            var fieldKey = fieldKeys[i], objArray = [];
            if (dataObj[fieldKey].length !== 0) {
                objArray = dataObj[fieldKey].filter(item => item[indicatorKeys[fieldKey]] === 'X');
            }
            if (objArray.length !== 0) {
                for (var j of dataObj[fieldKey]) {
                    if (objArray.indexOf(j) === -1) objArray.push(j);
                }
                dataObj[fieldKey] = objArray;
            }
        }
        return dataObj;
    },

    updateSelectedContactData(dataObj, contactType, contactLimit, value, encValue) {
        /***********************
        Change type : Security changes for phone numbers
        Changed by: Sai Aman Pothuganti
        Date : 06-10-2020
        ************************/
        let data = { ...dataObj };
        dataObj.addContactLimitArr[contactType] = contactLimit;
        dataObj.addContactCheckedStatusArr[contactType][contactLimit - 1] = true;
        dataObj.addContactValueArr[contactType][contactLimit - 1] = value;
        dataObj.addContactEncValueArr[contactType][contactLimit - 1] = encValue;
        return data;
    },

    getAddNewValueFlag(fetchPrefDetailsState, serviceCallType) {
        return fetchPrefDetailsState && fetchPrefDetailsState.isfetchPreferenceCallSucceededJustNow && (serviceCallType === 'addContact' || serviceCallType === 'modifyContact');
    },

    getDefaultFetchPrefDetailsState() {
        return {
            isfetchPreferenceCallSucceededJustNow: false, 
            deviceType: '', 
            value: '',
            previousSelectedValue: '',
            maskedPhoneNumber: '',
        };
    },

    getModifiedAddContactCheckedStatusArr(existingAddContactCheckedStatusArr, fetchPrefDetailsState, existingAddContactLimitArr, serviceCallType){
        var obj = {...existingAddContactCheckedStatusArr};
        var deviceType = fetchPrefDetailsState.deviceType;
        serviceCallType === 'addContact' && existingAddContactLimitArr[deviceType]<3 ? obj[deviceType][existingAddContactLimitArr[deviceType]] = true : null;
        return obj;
    },

    getModifiedAddContactLimitArr(existingAddContactLimitArr, fetchPrefDetailsState, serviceCallType){
        var obj = {...existingAddContactLimitArr};
        var deviceType = fetchPrefDetailsState.deviceType;
        serviceCallType === 'addContact' && obj[deviceType]<3 ? obj[deviceType]++ : null;
        return obj;
    },

    getModifiedContactValueArr(existingValueArr, existingEncValueArr, fetchPrefDetailsState, serviceCallType, isEncryptValueArray){
        var obj = {...existingValueArr};
        var encValueObj = {...existingEncValueArr};
        var deviceType = fetchPrefDetailsState.deviceType;
        var isAddContact = serviceCallType==='addContact' ? true : false;
        var isModifyContact = serviceCallType==='modifyContact' ? true : false;
        var isDeleteContact = serviceCallType==='deleteContact' ? true : false;
        var indexOfEmptyValue = obj[deviceType].indexOf('');
        if(isAddContact){
            indexOfEmptyValue > -1 && indexOfEmptyValue < 3 ? obj[deviceType][indexOfEmptyValue] = deviceType === 'email' ? fetchPrefDetailsState.value : isEncryptValueArray ? fetchPrefDetailsState.value : fetchPrefDetailsState.maskedPhoneNumber : null;
        }
        if(isModifyContact){
            obj = this.getModifiedValueArrForModifyContact(obj, encValueObj, deviceType, fetchPrefDetailsState, isEncryptValueArray);
        }
        return obj;
    },

    getModifiedValueArrForModifyContact(existingValueArr, existingEncValueArr, deviceType, fetchPrefDetailsState, isEncryptValueArray){
        var obj = {...existingValueArr};
        var encValueObj = {...existingEncValueArr};
        for(let i=0;i<encValueObj[deviceType].length;i++){
            let modifyValueFlag = deviceType === 'email' ? obj[deviceType][i] === fetchPrefDetailsState.previousSelectedValue : encValueObj[deviceType][i] === fetchPrefDetailsState.previousSelectedValue;
            modifyValueFlag && obj[deviceType][i] ? deviceType === 'email' ? obj[deviceType][i] = fetchPrefDetailsState.value : obj[deviceType][i] = isEncryptValueArray ? fetchPrefDetailsState.value : fetchPrefDetailsState.maskedPhoneNumber : null;
        }
        if(deviceType === 'email') return obj;
        deviceType = deviceType==='voice' ? 'text' : 'voice';
        for(let j=0;j<encValueObj[deviceType].length;j++){
            let modifyValueFlag = encValueObj[deviceType][j] === fetchPrefDetailsState.previousSelectedValue;
            modifyValueFlag && obj[deviceType][j] ? obj[deviceType][j] = isEncryptValueArray ? fetchPrefDetailsState.value : fetchPrefDetailsState.maskedPhoneNumber : null;
        }
        return obj;
    },

};

export default NotificationHelperTwo;